export const verifyJWT = async (JWT) => {
	let req = await fetch(`${process.env.REACT_APP_API_URL}`);
	let res = await req.json();
	return res;
}

export const refreshToken = async (JWT) => {
	let req = await fetch(`${process.env.REACT_APP_API_URL}`);
	let res = await req.json();
	return res;
}
export const saveTolocal = (key, value) => {
	localStorage.setItem(key, value);
}
export const getFromLocal = (key) => {
	return localStorage.getItem(key)
}
export const deleteFromLocal = (key) => {
	localStorage.removeItem(key);
}
export const defaultRoles = {
	"1": [2, 7, 15, 16]
}
export const convertArrayValuesToString = (array) => {
	let stringArray = [];
	array.map((v) => stringArray.push(`${v}`))
	return stringArray;
}
const numbers = '0123456789';
const upperCaseLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const lowerCaseLetters = 'abcdefghijklmnopqrstuvwxyz';
const getRandomLower = () => {
	return lowerCaseLetters[Math.floor(Math.random() * lowerCaseLetters.length)];
}
const getRandomNumber = () => {
	return numbers[Math.floor(Math.random() * numbers.length)];
}
const getRandomSymbol = () => {
	let specialCharacters = '!%&?_#$*-@';
	return specialCharacters[Math.floor(Math.random() * specialCharacters.length)];
}
const getRandomUpper = () => {
	return upperCaseLetters[Math.floor(Math.random() * upperCaseLetters.length)];
}
export const generatePassword = (passLength) => {
	let passwordLength = passLength || 10;
	let generatedPassword = '';
	let variationsCount = [1, 1,1,1].length
	for (let i = 0; i < passwordLength; i += variationsCount) {
		generatedPassword += getRandomNumber()
		generatedPassword += getRandomSymbol()
		generatedPassword += getRandomLower()
		generatedPassword += getRandomUpper()
	}
	const finalPassword = generatedPassword.slice(0, passwordLength);

	return finalPassword;
}